"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var diagnosis_item_status_1 = require("../../model/diagnosis-item-status");
var CanDiagnosisItemComponent = /** @class */ (function () {
    function CanDiagnosisItemComponent() {
    }
    CanDiagnosisItemComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(CanDiagnosisItemComponent.prototype, "attribute", {
        get: function () {
            return this._attribute;
        },
        set: function (attribute) {
            this._attribute = attribute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanDiagnosisItemComponent.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (status) {
            this._status = status;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanDiagnosisItemComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    CanDiagnosisItemComponent.prototype.timeout = function () {
        return this._status === diagnosis_item_status_1.DiagnosisItemStatus.TIMEOUT;
    };
    CanDiagnosisItemComponent.prototype.success = function () {
        return this._status === diagnosis_item_status_1.DiagnosisItemStatus.SUCCESS;
    };
    CanDiagnosisItemComponent.prototype.failed = function () {
        return this._status === diagnosis_item_status_1.DiagnosisItemStatus.FAILED;
    };
    CanDiagnosisItemComponent.prototype.running = function () {
        return this._status === diagnosis_item_status_1.DiagnosisItemStatus.RUNNING;
    };
    CanDiagnosisItemComponent.ctorParameters = function () { return []; };
    return CanDiagnosisItemComponent;
}());
exports.CanDiagnosisItemComponent = CanDiagnosisItemComponent;
//# sourceMappingURL=can-diagnosis-item.component.js.map


// WEBPACK FOOTER //
// can-diagnosis-item.component.js